import { createElement } from 'react';
import { _ as _objectWithoutProperties, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Form as Form$1 } from '@vebox/etui-system-elements';

const _excluded = ["children", "styles"];
function Form(_ref) {
  let {
      children,
      styles = {}
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(Form$1, _extends({}, props, styles.root), children);
}

export default Form;
